/** @format */

import React, { Component } from 'react';
import { Grid, Icon, Modal } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import ArrowBack from '../../../../../../public/images/arrow-back.png';
import ArrowForward from '../../../../../../public/images/arrow-foward.png';
import './RequestPartGallery.css';

inject('RequestsStore');
@observer
class RequestPartGallery extends Component {
  state = {
    galleryOpened: false,
    currentImg: 0,
  };

  componentDidMount = () => {
    let { RequestsStore } = this.props;
    if (typeof this.props.images === 'undefined') {
      RequestsStore.initializeGallery();
    }
  };

  openGallery = photoId => {
    this.setState({ galleryOpened: true, currentImg: photoId });
  };

  closeGallery = photoId => {
    this.setState({ galleryOpened: false, currentImg: 0 });
  };

  renderRemoveButtons = index => {
    if (this.props.removes) {
      return (
        <Icon
          className="clickable gallery-item-remove"
          name="trash"
          color="red"
          onClick={() => this.props.click(index)}
        />
      );
    } else {
      return null;
    }
  };

  prevPhoto = () => {
    let images = this.props.images;
    let currentImg =
      this.state.currentImg === 0
        ? images.length - 1
        : this.state.currentImg - 1;
    this.setState({ currentImg }, () => {
      // console.log(this.state.currentImg)
    });
  };

  nextPhoto = () => {
    let images = this.props.images;
    let currentImg =
      this.state.currentImg === images.length - 1
        ? 0
        : this.state.currentImg + 1;
    this.setState({ currentImg }, () => {
      // console.log(this.state.currentImg)
    });
  };

  renderImages = () => {
    let images = this.props.images;
    let imagesList = null;
    if (images.length !== 0) {
      imagesList = images.map((image, index) => {
        if (typeof image !== 'undefined' && image !== null) {
          return (
            <Grid.Column className="gallery-item" key={`image-${index}`}>
              <img
                onClick={
                  this.props.removes ? null : () => this.openGallery(index)
                }
                src={image}
                style={{
                  width: '100%',
                }}
                alt={index}
              />
              {this.renderRemoveButtons(index)}
            </Grid.Column>
          );
        } else {
          return null;
        }
      });
    }
    return imagesList;
  };

  render() {
    let { images } = this.props;
    return (
      <div>
        <Grid columns={4}>
          <Grid.Row>{this.renderImages()}</Grid.Row>
        </Grid>
        <Modal open={this.state.galleryOpened}>
          <Modal.Content className="gallery-content">
            <img
              src={images[this.state.currentImg]}
              style={{ maxWidth: '100%' }}
              alt="current"
            ></img>
          </Modal.Content>
          <div
            style={{ color: 'black' }}
            className="close-button"
            onClick={() => {
              this.closeGallery();
            }}
          >
            X
          </div>
          <div className="gallery-arrow-back">
            <img
              onClick={() => this.prevPhoto()}
              src={ArrowBack}
              alt="back"
            ></img>
          </div>
          <div className="gallery-arrow-foward">
            <img
              onClick={() => this.nextPhoto()}
              src={ArrowForward}
              alt="forward"
            ></img>
          </div>
        </Modal>
      </div>
    );
  }
}

export default RequestPartGallery;
